/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErsPriceDTO } from './ers-price-dto';
import { ErsActivatedPerMonthDTO } from './ers-activated-per-month-dto';


export interface CustomerErsUsageDTO { 
    /**
     * Required usage data for year
     */
    year?: number;
    /**
     * Total number of billable ERSes for selected year
     */
    total?: number;
    activated?: Array<ErsActivatedPerMonthDTO>;
    /**
     * How many ERSes are billable with standard (billingTier == 0) or increased prices (billingTier greater than 0) for selected year.
     */
    billable?: Array<ErsPriceDTO>;
    /**
     * Total number of billable external ERSes for selected year
     */
    totalExternal?: number;
    /**
     * How many external ERSes are billable with standard (billingTier == 0) or increased prices (billingTier greater than 0) for selected year.
     */
    billableExternal?: Array<ErsPriceDTO>;
}

export class ClsCustomerErsUsageDTO { 
    /**
     * Required usage data for year
     */
    year?: number = undefined;
    /**
     * Total number of billable ERSes for selected year
     */
    total?: number = undefined;
    activated?: Array<ErsActivatedPerMonthDTO> = undefined;
    /**
     * How many ERSes are billable with standard (billingTier == 0) or increased prices (billingTier greater than 0) for selected year.
     */
    billable?: Array<ErsPriceDTO> = undefined;
    /**
     * Total number of billable external ERSes for selected year
     */
    totalExternal?: number = undefined;
    /**
     * How many external ERSes are billable with standard (billingTier == 0) or increased prices (billingTier greater than 0) for selected year.
     */
    billableExternal?: Array<ErsPriceDTO> = undefined;
}

